export const LOCAL_STORAGE_KEY_HLW_LETTER_SPACING = "hlwLetterSpacing";
